import React from "react";
import { Button } from "antd";
import usePortal from "react-useportal";
import { TI_COMPARE_MODAL_CLOSE_BUTTON } from "../../../Constants";
import { StyledButton } from "../../../styled-components/Button";

export default function ModalFixed({
  children,
  visible,
  setVisible,
  closeButtonRef,
  openChartModalButtonRef,
}) {
  const { Portal } = usePortal();

  return (
    <Portal>
      <div style={CONTAINER_STYLE} hidden={!visible}>
        <StyledButton
          ref={closeButtonRef}
          style={STYLE_CLOSE}
          shape="circle"
          icon={"close"}
          onClick={() => {
            setTimeout(() => {
              if (openChartModalButtonRef.current) {
                openChartModalButtonRef.current.focus();
              }
            }, 300);
            setVisible(false);
          }}
          aria-label="닫기"
          // tabIndex={TI_COMPARE_MODAL_CLOSE_BUTTON}
        >
          닫기
        </StyledButton>
        {children}
      </div>
    </Portal>
  );
}

const CONTAINER_STYLE = {
  position: "absolute",
  padding: "4px",
  margin: "8px",
  background: "rgba(255, 255, 255, 1)",
  right: 40,
  top: 234,
  width: "800px",
  height: "430px",
  overflowX: "scroll",
  overflowY: "hidden",
  border: "1px solid grey",
  zIndex: 2,
};

const STYLE_CLOSE = {
  position: "absolute",
  top: 10,
  right: 10,
  // padding: "4px",
  zIndex: 20,
};
